"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
var model_reducer_1 = require("./model.reducer");
function createModelStore(initialValue) {
    return redux_1.createStore(model_reducer_1.modelReducer, initialValue);
}
exports.createModelStore = createModelStore;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibW9kZWwuc3RvcmUuanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9zdG9yZS9tb2RlbC5zdG9yZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLCtCQUFvQztBQUNwQyxpREFBK0M7QUFFL0MsU0FBZ0IsZ0JBQWdCLENBQUMsWUFBWTtJQUN6QyxPQUFPLG1CQUFXLENBQUMsNEJBQVksRUFBRSxZQUFZLENBQUMsQ0FBQztBQUNuRCxDQUFDO0FBRkQsNENBRUMifQ==